export const LIST_DATA_ANALYSIS_REQUEST = 'LIST_DATA_ANALYSIS_REQUEST'
export const LIST_DATA_ANALYSIS_SUCCESS = 'LIST_DATA_ANALYSIS_SUCCESS'
export const LIST_DATA_ANALYSIS_FAIL = 'LIST_DATA_ANALYSIS_FAIL'

export const LIST_DATA_ANALYSIS_CONFIG_LIST_REQUEST =
  'LIST_DATA_ANALYSIS_CONFIG_LIST_REQUEST'
export const LIST_DATA_ANALYSIS_CONFIG_LIST_SUCCESS =
  'LIST_DATA_ANALYSIS_CONFIG_LIST_SUCCESS'
export const LIST_DATA_ANALYSIS_CONFIG_LIST_FAIL =
  'LIST_DATA_ANALYSIS_CONFIG_LIST_FAIL'

export const LIST_DATA_ANALYSIS_PROJECT_REQUEST =
  'LIST_DATA_ANALYSIS_PROJECT_REQUEST'
export const LIST_DATA_ANALYSIS_PROJECT_SUCCESS =
  'LIST_DATA_ANALYSIS_PROJECT_SUCCESS'
export const LIST_DATA_ANALYSIS_PROJECT_FAIL = 'LIST_DATA_ANALYSIS_PROJECT_FAIL'

export const LIST_DATA_ANALYSIS_SUMMARY_REQUEST =
  'LIST_DATA_ANALYSIS_SUMMARY_REQUEST'
export const LIST_DATA_ANALYSIS_SUMMARY_SUCCESS =
  'LIST_DATA_ANALYSIS_SUMMARY_SUCCESS'
export const LIST_DATA_ANALYSIS_SUMMARY_FAIL = 'LIST_DATA_ANALYSIS_SUMMARY_FAIL'

export const CREATE_DATA_ANALYSIS_REQUEST = 'CREATE_DATA_ANALYSIS_REQUEST'
export const CREATE_DATA_ANALYSIS_SUCCESS = 'CREATE_DATA_ANALYSIS_SUCCESS'
export const CREATE_DATA_ANALYSIS_FAIL = 'CREATE_DATA_ANALYSIS_FAIL'

export const CREATE_DATA_ANALYSIS_PROJECT_REQUEST =
  'CREATE_DATA_ANALYSIS_PROJECT_REQUEST'
export const CREATE_DATA_ANALYSIS_PROJECT_SUCCESS =
  'CREATE_DATA_ANALYSIS_PROJECT_SUCCESS'
export const CREATE_DATA_ANALYSIS_PROJECT_FAIL =
  'CREATE_DATA_ANALYSIS_PROJECT_FAIL'

export const DETAIL_DATA_ANALYSIS_REQUEST = 'DETAIL_DATA_ANALYSIS_REQUEST'
export const DETAIL_DATA_ANALYSIS_SUCCESS = 'DETAIL_DATA_ANALYSIS_SUCCESS'
export const DETAIL_DATA_ANALYSIS_FAIL = 'DETAIL_DATA_ANALYSIS_FAIL'

export const UPDATE_DATA_ANALYSIS_REQUEST = 'UPDATE_DATA_ANALYSIS_REQUEST'
export const UPDATE_DATA_ANALYSIS_SUCCESS = 'UPDATE_DATA_ANALYSIS_SUCCESS'
export const UPDATE_DATA_ANALYSIS_FAIL = 'UPDATE_DATA_ANALYSIS_FAIL'

export const DELETE_DATA_ANALYSIS_REQUEST = 'DELETE_DATA_ANALYSIS_REQUEST'
export const DELETE_DATA_ANALYSIS_SUCCESS = 'DELETE_DATA_ANALYSIS_SUCCESS'
export const DELETE_DATA_ANALYSIS_FAIL = 'DELETE_DATA_ANALYSIS_FAIL'

export const DELETE_DATA_ANALYSIS_PROJECT_REQUEST =
  'DELETE_DATA_ANALYSIS_PROJECT_REQUEST'
export const DELETE_DATA_ANALYSIS_PROJECT_SUCCESS =
  'DELETE_DATA_ANALYSIS_PROJECT_SUCCESS'
export const DELETE_DATA_ANALYSIS_PROJECT_FAIL =
  'DELETE_DATA_ANALYSIS_PROJECT_FAIL'

export const RESET_DATA_ANALYSIS = 'RESET_DATA_ANALYSIS'
